import React from "react";

const EditStoryContext = React.createContext({
    saveScriptChanges: () => {},
  });
  
  export default EditStoryContext;